export const addresses = {
  messageSplatterToken: "0x29ef4ee08c5bc5e158b96665c49adf6a26392153",
};
